import { FC } from 'react';
import { Skeleton } from './Skeleton';


function getQueryParams() {
    const params: Record<string, string> = {};
    const queryString = window.location.search.substring(1);
    const pairs = queryString.split('&');
    for (const pair of pairs) {
        const [key, value] = pair.split('=');
        params[decodeURIComponent(key)] = decodeURIComponent(value || '');
    }
    return params;
}

// console.log("crossOriginIsolated", window.crossOriginIsolated,
//     "isSecureContext", window.isSecureContext,
//     "origin", window.origin,
//     "location", window.location.href)

export const App: FC<{}> = () => {
    const params = getQueryParams();
    const videoSource = params.vs || "camera";
    return (
            <Skeleton videoSource={videoSource} />
    )
}